/*
 * File: PostChargeUIDialog.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 09/17/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: This controls whether the diagnosis or procedure form is showing
 */
import React, { useState, useEffect } from "react";
import DiagnosisSearchForm from "./diagnosis/DiagnosisSearch";
import ProcedureCodeSearchForm from "./procedure/ProcedureCodeSearchForm";
import UIDialog from "components/ui/UIDialog";
import CloseIcon from "@material-ui/icons/Close";
import ProcedureForm from "./procedure/ProcedureForm";
import ChargeModel from "../store/ChargeModel";
import { clone } from "mobx-state-tree";
import PropTypes from "prop-types";
import { observer, PropTypes as mobxProbTypes } from "mobx-react";

const PostChargeUIDialog = ({
  editingChargeModel,
  parentCallBack,
  editFormSaveChanges,
  postChargesModel,
  title,
  uiSearchStore,
  selectedDiagnosesStore,
  feeScheduleName
}) => {
  const [showProcedureCodeForm, setShowProcedureCodeForm] = useState(false);
  const [newChargeModel, setNewChargeModel] = useState(() => {
    return ChargeModel.create();
  });
  const [editingChargeModelCopy] = useState(() => {
    if (editingChargeModel) {
      return clone(editingChargeModel);
    } else {
      return null;
    }
  });

  useEffect(() => {
    selectedDiagnosesStore.selectedDiagnoses.forEach(formDiagnosis => {
      newChargeModel.addDiagnosis(
        formDiagnosis.umlsId,
        formDiagnosis.index,
        formDiagnosis.diagnosis,
        formDiagnosis.pointer,
        formDiagnosis.code
      );
    });
  }, [selectedDiagnosesStore, newChargeModel]);

  const diagnosisSearchCallBack = () => {
    parentCallBack();
  };
  const procedureCodeSearchCallBack = () => {
    setShowProcedureCodeForm(true);
  };
  const procedureAddAnotherCallBack = () => {
    const newChargeModel = ChargeModel.create();
    setNewChargeModel(newChargeModel);
    setShowProcedureCodeForm(false);
  };
  const editRowSave = () => {
    editFormSaveChanges(editingChargeModelCopy);
  };
  const addRowSave = () => {
    postChargesModel.addCharge(newChargeModel);
    closeDiaglog();
  };
  const closeDiaglog = () => {
    parentCallBack();
  };
  const searchFormContent = () => {
    if (title === "Diagnosis") {
      return (
        <DiagnosisSearchForm
          parentCallBack={diagnosisSearchCallBack}
          uiSearchStore={uiSearchStore}
          selectedDiagnosesStore={selectedDiagnosesStore}
        />
      );
    } else if (title === "Procedures") {
      return procedureFormContent();
    }
  };
  const procedureFormContent = () => {
    if (editingChargeModel) {
      return (
        <ProcedureForm
          formSubmitMethod={editRowSave}
          chargeModel={editingChargeModelCopy}
          postChargesModel={postChargesModel}
          editing={true}
        />
      );
    } else if (showProcedureCodeForm) {
      return (
        <ProcedureForm
          formSubmitMethod={addRowSave}
          procedureAddAnotherCallBack={procedureAddAnotherCallBack}
          chargeModel={newChargeModel}
          postChargesModel={postChargesModel}
          editing={false}
        />
      );
    } else {
      return (
        <ProcedureCodeSearchForm
          parentCallBack={procedureCodeSearchCallBack}
          uiSearchStore={uiSearchStore}
          feeScheduleName={feeScheduleName}
          chargeModel={newChargeModel}
        />
      );
    }
  };
  const rightNav = () => {
    return <CloseIcon onClick={closeDiaglog} color="inherit" />;
  };
  return (
    <div>
      <UIDialog
        noPadding={true}
        fullScreen={true}
        open={true}
        content={searchFormContent}
        title={title}
        rightNav={rightNav}
      />
    </div>
  );
};

PostChargeUIDialog.propTypes = {
  editingChargeModel: PropTypes.object,
  selectedDiagnoses: mobxProbTypes.observableArray.isRequired,
  parentCallBack: PropTypes.func.isRequired,
  editFormSaveChanges: PropTypes.func,
  postChargesModel: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  uiSearchStore: PropTypes.object,
  selectedDiagnosesStore: PropTypes.object,
  feeScheduleName: PropTypes.string
};

export default observer(PostChargeUIDialog);
